module.exports = __webpack_public_path__ + "assets/img/37_1013.5f721001.jpg";